module.exports = __webpack_public_path__ + "static/media/Bookmark_Outline_Icon.b11f8364.png";